"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogStreams = getLogStreams;
const client_cloudwatch_logs_1 = require("@aws-sdk/client-cloudwatch-logs");
function getLogStreams(_a) {
    return __awaiter(this, arguments, void 0, function* ({ logGroupName, }) {
        const cloudWatchLogsClient = new client_cloudwatch_logs_1.CloudWatchLogsClient();
        const logStreamNames = [];
        let nextToken;
        try {
            do {
                const command = new client_cloudwatch_logs_1.DescribeLogStreamsCommand({
                    logGroupName,
                    orderBy: "LastEventTime",
                    descending: false,
                    nextToken,
                });
                const response = yield cloudWatchLogsClient.send(command);
                if (response.logStreams) {
                    logStreamNames.push(...response.logStreams.map((stream) => stream.logStreamName || ""));
                }
                nextToken = response.nextToken;
            } while (nextToken);
        }
        catch (error) {
            console.error("Error retrieving log streams:", error);
            throw error;
        }
        return logStreamNames;
    });
}
